import React, { Component } from 'react';

export class PageNotFound extends Component {
    displayName = PageNotFound.name

    constructor(props) {
        super(props);
    }

    render() {
        return (
            this.props.small ?
                <h4> Loading... <i className="fas fa-spinner fa-spin"></i> </h4>
                :
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
                    <div style={{ textAlign: "center" }}>
                        <div style={{ color: '#006c98', marginTop: "15px" }}>
                            <i className="fas fa-blind fa-2x"></i>
                        </div>
                        <h1>Page Not Found</h1>
                        <p>The page you are looking for does not exist or you may have entered the wrong url.</p>
                    </div>
                </div>
        );
    }
}

PageNotFound.defaultProps = {
    small: false
}


// WEBPACK FOOTER //
// ./src/components/PageNotFound.js